import { makeStyles, type Theme } from '@material-ui/core/styles';

const drawerWidth = 230;

const useStyles = makeStyles((theme: Theme) => ({
	stepsContainer: {
		'& .MuiStepIcon-completed': {
			color: theme.palette.secondary.main,
		},
	},
	activeSection: {
		color: theme.palette.secondary.main + '!important',
		cursor: 'pointer',
	},
	questionCard: {
		padding: '16px 24px',
	},
	buttons: {
		width: '100%',
		padding: 16,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	divider: {
		width: '100%',
		margin: '16px 0px',
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		paddingTop: 64,
		[theme.breakpoints.down('md')]: {
			paddingTop: 24,
		},
	},
	saveContainer: {
		width: '100%',
		marginTop: 24,
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'flex-end',
	},
}));

export default useStyles;
